export const TRIGGER_TYPES = [
  { value: 'manual', label: 'Manual Trigger', group: 'General' },
  { value: 'schedule', label: 'Schedule (Cron)', group: 'General' },
  { value: 'contact_created', label: 'Contact Created', group: 'CRM' },
  { value: 'form_submitted', label: 'Form Submitted', group: 'CRM' },
  { value: 'appointment_booked', label: 'Appointment Booked', group: 'CRM' },
  { value: 'deal_created', label: 'Deal Created', group: 'Sales' },
  { value: 'deal_won', label: 'Deal Won', group: 'Sales' },
  { value: 'deal_lost', label: 'Deal Lost', group: 'Sales' },
  { value: 'payment_received', label: 'Payment Received', group: 'Billing' },
  { value: 'invoice_overdue', label: 'Invoice Overdue', group: 'Billing' },
  { value: 'email_received', label: 'Email Received', group: 'Messaging' },
  { value: 'sms_received', label: 'SMS Received', group: 'Messaging' },
  { value: 'webhook_inbound', label: 'Inbound Webhook', group: 'System' },
];

export const ACTION_TYPES = [
  { value: 'send_email', label: 'Send Email', group: 'Messaging' },
  { value: 'send_sms', label: 'Send SMS', group: 'Messaging' },
  { value: 'ai_research', label: 'AI Research', group: 'AI' },
  { value: 'ai_compose', label: 'AI Compose Message', group: 'AI' },
  { value: 'ai_summarize', label: 'AI Summarize/Report', group: 'AI' },
  { value: 'human_approval', label: 'Human Approval Gate', group: 'Flow' },
  { value: 'invoke_workflow', label: 'Run Sub-Workflow', group: 'Flow' },
  { value: 'for_each', label: 'For Each Item', group: 'Flow' },
  { value: 'wait_for_responses', label: 'Wait for Email Replies', group: 'Messaging' },
  { value: 'tally_to_sheet', label: 'Tally to Spreadsheet', group: 'Data' },
  { value: 'add_tag', label: 'Add Tag', group: 'CRM' },
  { value: 'remove_tag', label: 'Remove Tag', group: 'CRM' },
  { value: 'update_contact_field', label: 'Update Contact Field', group: 'CRM' },
  { value: 'create_deal', label: 'Create Deal', group: 'Sales' },
  { value: 'create_task', label: 'Create Task', group: 'CRM' },
  { value: 'notify_user', label: 'Notify User', group: 'System' },
  { value: 'webhook_outbound', label: 'Send Webhook', group: 'System' },
  { value: 'wait', label: 'Wait / Delay', group: 'Flow' },
  { value: 'condition', label: 'If / Else Condition', group: 'Flow' },
  { value: 'end', label: 'End Workflow', group: 'Flow' },
];

export const WORKFLOW_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'active', label: 'Active' },
  { value: 'paused', label: 'Paused' },
  { value: 'archived', label: 'Archived' },
];

export const TRIGGER_TYPE_VALUES = TRIGGER_TYPES.map(t => t.value);
export const ACTION_TYPE_VALUES = ACTION_TYPES.map(t => t.value);
